import { useLoad } from "@redotech/react-util/load";
import { NO_COVERAGE_PRODUCT_IDS } from "@redotech/redo-return-coverage-common/is-coverage-fee-product";
import { createContext, memo, ReactNode, useContext } from "react";
import { AuthContext } from "./auth";
import { RedoMerchantRpcClientContext } from "./rpc-client";

/**
 * Numeric Shopify product ids of the team's Redo coverage products, for
 * isCoverageFeeProduct id matching. Empty until loaded or when unauthenticated.
 */
export const CoverageProductIdsContext = createContext<ReadonlySet<string>>(
  NO_COVERAGE_PRODUCT_IDS,
);

export const CoverageProductIdsProvider = memo(
  function CoverageProductIdsProvider({
    children,
  }: {
    children: ReactNode | ReactNode[];
  }) {
    const rpcClient = useContext(RedoMerchantRpcClientContext);
    const auth = useContext(AuthContext);
    const load = useLoad(
      async () =>
        auth && rpcClient
          ? new Set(
              (await rpcClient.getCoverageProductIds(null))
                .redoCoverageProductIds,
            )
          : NO_COVERAGE_PRODUCT_IDS,
      [auth, rpcClient],
    );
    return (
      <CoverageProductIdsContext.Provider
        value={load.value ?? NO_COVERAGE_PRODUCT_IDS}
      >
        {children}
      </CoverageProductIdsContext.Provider>
    );
  },
);
